module.exports = __webpack_public_path__ + "static/media/Believer.c61810d1.jpg";